module.exports = __webpack_public_path__ + "static/media/Alguicida.9645cdbe.png";